import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventTabsStepService {
  public status = false;

  private _step: number = 0;
  set step(step: number) {
    if(this.status) {
      this._step = step;
    }
  }
  get step(): number {
    return this._step;
  }

  public firstStep: number = 0;
  public lastStep: number = 0;

  public onPreviousStepSubject: Subject<any> = new Subject();
  public onNextStepSubject: Subject<any> = new Subject();

  constructor(
  ) {}

  previousStep() {
    this.onPreviousStepSubject.next(null);
  }

  nextStep() {
    this.onNextStepSubject.next(null);
  }

  reset() {
    this._step = 0;

    this.firstStep = 0;
    this.lastStep = 0;
  }
}
